// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3dsvD","buttons":"SendReceipts_buttons__1vzAp","email":"SendReceipts_email__1jLwi","bookApptTitle":"SendReceipts_bookApptTitle__2d4Vs"};